export const endPoint = process.env.REACT_APP_PROTEOAEK_API_ENDPOINT;

const BASE_URL = `${endPoint}/`;
export const PA_API_ENDPOINTS = {
  BASE_URL: BASE_URL,
  //   auth
  REGISTER_USER: `${BASE_URL}auth/register`,
  LOGIN_USER: `${BASE_URL}auth/login`,
  GET_TOKEN: `${BASE_URL}auth/token`,
  REFRESH_TOKEN: `${BASE_URL}auth/refresh-token`,

  //analysis
  UPLOAD_FILE: `${BASE_URL}aws/upload-file`,
  PRE_ANALYSIS: `${BASE_URL}analysis/pre-analysis`,
  EXP_ANALYSIS: `${BASE_URL}analysis/pre-analysis-direct`,
  NORM_DATA: `${BASE_URL}analysis/normalization`,
  DIFF_EXP_ANALYSIS: `${BASE_URL}analysis/differential-expression-analysis`,
  DIFF_VOLCANO_PLOT: `${BASE_URL}analysis/differential-volcano-plot`,
  DIFF_HEATMAP: `${BASE_URL}analysis/differential-heatmap`,
  DIFF_KMEANS: `${BASE_URL}analysis/differential-kmeans`,
  GENE_ONTOLOGY: `${BASE_URL}analysis/gene-ontology`,
  BATCH_CORRECTION: `${BASE_URL}analysis/batch-correction`,
  LABEL_FREE_ANALYSIS: `${BASE_URL}analysis/lable-free-analysis`,
  KEGG_PATHWAY: `${BASE_URL}analysis/kegg-pathway`,
  STRING_PATHWAY: `${BASE_URL}analysis/string-analysis`,
  DATA_VISUAL: `${BASE_URL}visualization/chose-plot`,
  VISUAL_PLOT: `${BASE_URL}visualization/vizualize`,
  PROTEOARK_CONTACT:`${BASE_URL}email/send-email`,

};
